var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricing1Stpage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.53,219.61v60.78c0,3.2,5,3.2,5,0V219.61c0-3.2-5-3.2-5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.55,236.86c-2.19-4.53-7.75-4.73-12.12-4.93q-9.59-.44-19.18-.48-19.18-.1-38.33,1.32a2.5,2.5,0,0,0-.66,4.88c27.62,9.59,57.86,12.27,83.47,27.19L90,260.21a286.66,286.66,0,0,0-62,12.34c-3,1-1.74,5.76,1.32,4.79A280.75,280.75,0,0,1,90,265.18c2.34-.21,3.51-3.31,1.25-4.63-26-15.16-56.61-18-84.66-27.69l-.66,4.88q17.5-1.29,35.07-1.33,8.57,0,17.14.28c2.81.09,5.65.11,8.44.38,1.82.18,3.83.52,4.69,2.29,1.39,2.88,5.67.37,4.29-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.57,219.61v60.78c0,3.2,5,3.2,5,0V219.61c0-3.2-5-3.2-5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.59,236.86c-2.19-4.53-7.75-4.73-12.11-4.93q-9.59-.44-19.18-.48-19.19-.1-38.34,1.32a2.5,2.5,0,0,0-.66,4.88c27.62,9.59,57.86,12.27,83.48,27.19l1.25-4.63a286.66,286.66,0,0,0-62,12.34c-3,1-1.74,5.76,1.32,4.79A280.87,280.87,0,0,1,494,265.18c2.34-.21,3.52-3.31,1.25-4.63-26-15.16-56.61-18-84.66-27.69l-.66,4.88q17.51-1.29,35.07-1.33,8.58,0,17.14.28c2.81.09,5.65.11,8.45.38,1.81.18,3.83.52,4.68,2.29,1.39,2.88,5.68.37,4.29-2.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing1Stpage);
export default __webpack_public_path__ + "static/media/pricing 1st page.768d15c5d9796ea265455dc1e3ec47d9.svg";
export { ForwardRef as ReactComponent };